export class FacultySearchModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    institutionEmailAddress: string;
    city: string;
    state: string;
    contactId: string;
    contactNumber: string;
    isEligibleToAdd: Boolean;
    cityStateFormatted: string;
}
